import { templateSkeletonStatusOptions } from "constants/v2/appConstants";
import { createSelector } from "reselect";

import { templatesEntityAdapter, templatesSlice } from "./slice";

const templatesState = (state) => state[templatesSlice.name];

const selectTemplatesState = (state) => state[templatesSlice.name];

const selectTemplateModals = createSelector(templatesState, (state) => state.modals);

export const selectTemplateNotification = createSelector(templatesState, (state) => state.templateNotification);

export const selectFromGenerateHighlights = createSelector(templatesState, (state) => state.fromGenerateHighlights);

export const selectTemplateIds = createSelector(templatesState, (state) =>
  templatesEntityAdapter.getSelectors().selectIds(state),
);

export const selectTemplateEntities = createSelector(templatesState, (state) =>
  templatesEntityAdapter.getSelectors().selectEntities(state),
);

export const selectTemplateDetailsById = createSelector(
  selectTemplatesState,
  (state, props) => ({
    templateId: props.templateId,
  }),
  (state, { templateId }) => {
    return templatesEntityAdapter.getSelectors().selectById(state, templateId) || null;
  },
);

export const selectTemplateThumbnailUrlById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.thumbnail_url,
);

export const selectTemplateTitleById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.title,
);

export const selectTemplateProjectIdById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.project_id,
);

export const selectTemplateEntityIdById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.entity_id,
);

export const selectTemplateUpdatedAtById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.updated_at,
);
export const selectTemplateAspectRatioById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.aspect_ratio,
);

export const selectTemplateIsGenericById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.is_generic,
);

export const selectTemplateIsDynamicById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.type === "dynamic",
);

export const selectTemplateSportCategoryById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.sports_category,
);

export const selectTemplateTournamentById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.tournament_id,
);

export const selectTemplatesCount = createSelector(templatesState, (templateState) => templateState.count);

export const selectTemplateIdsCount = createSelector(selectTemplateIds, (templateIds) => templateIds?.length);

export const selectTemplatesModal = createSelector(selectTemplateModals, (modals) => modals.templatesModal);

export const selectCreateTemplatesModal = createSelector(selectTemplateModals, (modals) => modals.createTemplatesModal);

export const selectValidationsTemplatesModal = createSelector(
  selectTemplateModals,
  (modals) => modals.templateValidationsModal,
);

export const selectDeleteTemplatesModal = createSelector(selectTemplateModals, (modals) => modals.templateDeleteModal);

export const selectTemplatesSkeleton = createSelector(templatesState, (state) => state.skeletons);

export const selectTemplatesSkeletonProjectIds = createSelector(templatesState, (state) => {
  let inProgressProjectIds = [];

  (state.skeletons || []).forEach((skeleton) => {
    if (skeleton.status !== templateSkeletonStatusOptions.exportcomplete) inProgressProjectIds.push(skeleton.projectId);
  });

  return inProgressProjectIds;
});

export const selectTemplatesJobIds = createSelector(templatesState, (state) => {
  return state.templateJobIds;
});

export const selectTemplatePreviewUrlById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.preview_url,
);

export const selectActiveTemplateInfo = createSelector(templatesState, (state) => state.activeTemplateInfo);

export const selectTemplatePreviewModalId = createSelector(
  selectTemplateModals,
  (modals) => modals.templatePreviewModalId,
);

export const selectTemplateIdsByDateId = createSelector(
  templatesState,
  (state, props) => props.templateDateId,
  (templatesState, templateDateId) => templatesState?.groupByDate[templateDateId]?.data,
);

export const selectStudioTemplateGroupByDateIds = createSelector(templatesState, (studioTemplateState) =>
  Object.keys(studioTemplateState?.groupByDate),
);

export const selectStudioTemplateIds = createSelector(templatesState, (studioTemplateState) => {
  let templateIds = [];

  Object.keys(studioTemplateState?.groupByDate).forEach((dateId) => {
    const templateIdsOfThisDate = studioTemplateState?.groupByDate[dateId]?.data || [];

    templateIds = [...templateIds, ...templateIdsOfThisDate];
  });

  return templateIds;
});

export const selectTemplateAssetsFilters = createSelector(templatesState, (state) => state?.filters?.match_assets);

export const selectTemplateSegmentTypeById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.segment_type,
);

export const selectTemplateMatchTypeById = createSelector(
  selectTemplateDetailsById,
  (templateDetail) => templateDetail?.match_format,
);

export const selectHighlightEditorTemplateJobId = createSelector(
  templatesState,
  (state) => state?.highlightEditorTemplate?.jobId,
);

export const selectHighlightEditorTemplateProjectId = createSelector(
  templatesState,
  (state) => state?.highlightEditorTemplate?.projectId,
);

export const selectHighlightEditorTemplateClipId = createSelector(
  templatesState,
  (state) => state?.highlightEditorTemplate?.clipId,
);

export const selectHighlightEditorTemplateCompleted = createSelector(
  templatesState,
  (state) => state?.highlightEditorTemplate?.completed,
);

export const selectHighlightEditorTemplateId = createSelector(
  templatesState,
  (state) => state?.highlightEditorTemplate?.templateId,
);

export const selectTemplateValidationFields = createSelector(templatesState, (state) => state.validationFields);

export const selectIndividualApplicationClips = createSelector(
  templatesState,
  (state) => state.individualApplicationClips,
);
